export class Banco {
  public id!: number | string | null;
  public numeroBanco!: string;
  public nome!: string;
  public cnpj!: string;
  public bancoDigital!: boolean;
  public permiteOperacao!: boolean;
  public permiteCompra!: boolean;
  public ativo!: boolean;
  public tipoConta!: string;
  public operacao!: string;
  public agencia!: string;
  public dvAgencia!: string;
  public conta!: string;
  public dvConta!: string;
}